import React from "react";

import TableForms from "./table-forms";
import Form from "./form";
import { Switch, Route, useRouteMatch, withRouter } from "react-router-dom";
import "../../../../../styles/css/App.css";

function Forms({ history }) {
  
  let { path, url } = useRouteMatch();

  const open = (event, rowData) => {
    if (rowData !== undefined) {
      history.push(`${url}/` + rowData.id);
    }
  }

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <TableForms
            {...{
              open
            }}
          />
        </Route>
        <Route exact path={`${path}/:formId`}
          render={(props) => <Form formId={props.match.params.formId}/>}
        />
      </Switch>
    </div>
  );

}

export default withRouter(Forms);
